import { useTheme } from '@material-ui/core';
import moment from 'moment/moment';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Button } from '../../../../../components/Button';
import { Spacer } from '../../../../../components/Spacer';
import { Typography } from '../../../../../components/Typography';
import { updateBookingAction } from '../../../../../data/actions/bookingAction';
import { bookingKeys } from '../../../../../data/models/Booking';
import { trackEvent } from '../../../../../utils/analytics';
import { formatDateToMoment, formatMomentToDate } from '../../../../../utils/helpers';
import useStyles from './DateStyles';

const Date = ({ date, updateBooking }) => {
  const theme = useTheme();
  const classes = useStyles();

  const handleOnClick = (e) => {
    // make this active so we have better knowledge which time we're picking for
    trackEvent('Booking', 'Updating Date', 'Booking Calendar');
    updateBooking(bookingKeys.date, formatMomentToDate(moment(date)));
    updateBooking(bookingKeys.selectedExperiences, []);
  };

  return (
    <>
      <Button className={`${classes.container}`} onClick={handleOnClick} variant='outlined'>
        <Spacer direction='vertical' gap={0} style={{ width: '100%' }}>
          <Typography
            style={{
              fontWeight: theme.fontWeights.regular,
              lineHeight: 'normal',
              fontFamily: theme.baseTypography.numberFontFamily,
            }}
          >
            {formatMomentToDate(formatDateToMoment(date, 'YYYY-MM-DD'), 'DD/MM/YY')}
          </Typography>
        </Spacer>
      </Button>
    </>
  );
};

Date.defaultProps = {};

Date.propTypes = {
  date: PropTypes.string.isRequired,
  updateBooking: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  booking: state.booking,
  restaurant: state.restaurant,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      updateBooking: updateBookingAction,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(Date);
